/** Versão padrão ao publicar documento legal: data local em DD/MM/AAAA. */
export function defaultLegalDocumentVersion(date: Date = new Date()): string {
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = String(date.getFullYear())
  return `${day}/${month}/${year}`
}
